var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4,
    width: 48,
    height: 56,
    rx: 6,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 16,
    width: 28,
    height: 4,
    rx: 2,
    fill: "#E0E0E0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 26,
    width: 28,
    height: 4,
    rx: 2,
    fill: "#E0E0E0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 36,
    width: 28,
    height: 4,
    rx: 2,
    fill: "#E0E0E0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 46,
    width: 18,
    height: 4,
    rx: 2,
    fill: "#E0E0E0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4,
    width: 12,
    height: 56,
    rx: 3,
    fill: "#BBBBBB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 20,
    r: 3,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 30,
    r: 3,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 40,
    r: 3,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 50,
    r: 3,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.59efcc03d71f83320aaadc9129d4571b.svg";
export { ForwardRef as ReactComponent };